/** UTC calendar-day projection shared by core usage counters and the web date-range mirror.
 * Keep this importless source and web/lib/utcDay.ts byte-identical; contract tests pin the boundary. */
export function utcDayOf(atMs: number): string {
  return new Date(atMs).toISOString().slice(0, 10);
}
